import { Box, Card, CardContent, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import React from "react";
import AddressSelectDropdown from "./AddressSelectDropDown";
import { UpdateShipToAddressResponse } from "../../../../api/xtremeBff/xtremeBffInterfaces";
import { Address } from "../../types";

function DealerAddressContainer({
  children,
  title,
  identifier,
  selectable = false,
  disableSelection = false,
  updateAddress,
  currentAddress,
}: {
  children: React.ReactNode;
  title: string;
  identifier: string;
  selectable?: boolean;
  disableSelection?: boolean;
  updateAddress?: (res: UpdateShipToAddressResponse) => void;
  currentAddress?: Address;
}): JSX.Element {
  const theme = useTheme();

  return (
    <Box
      width="100%"
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        gap: 2,
      }}
    >
      <Card
        sx={{
          boxShadow: "none",
          flex: selectable ? 1 : 2,
        }}
      >
        <CardContent>
          <Typography
            sx={{
              fontWeight: "600",
              color: theme.tokens.FuelColorTextPrimary,
            }}
            variant="h4"
            data-testid={`${identifier}-addressType`}
          >
            {title}
          </Typography>
          {children}
        </CardContent>
      </Card>
      {selectable && (
        <Card
          sx={{
            boxShadow: "none",
            flex: 1,
            width: "24rem",
          }}
        >
          <CardContent>
            <AddressSelectDropdown
              updateAddress={updateAddress}
              currentAddress={currentAddress}
              disabled={disableSelection}
            />
          </CardContent>
        </Card>
      )}
    </Box>
  );
}

export default DealerAddressContainer;
